import { Layout, Skeleton } from "antd";
import { useMediaQuery } from "@mui/material";
import React from "react";
import "./Fallbacks.css";

const { Sider } = Layout;

/** Matches SideNavigation collapsed icon rows on desktop/tablet. */
const COLLAPSED_ICON_COUNT = 6;

/** Mirrors SideNavigation: 600px mobile drawer, 650px narrow sider, collapsed by default. */
export const SideNavFallback: React.FC = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const smallerMenu = useMediaQuery("(max-width: 650px)");
  const siderWidth = smallerMenu ? 190 : 230;

  if (isMobile) {
    return (
      <Skeleton.Button
        active
        shape="circle"
        className="app-fallback-mobile-menu-btn"
        aria-hidden
      />
    );
  }

  return (
    <Sider
      className="app-fallback-side-nav app-fallback-side-nav--collapsed"
      width={siderWidth}
      collapsedWidth={50}
      collapsed
      trigger={null}
      aria-hidden
    >
      {Array.from({ length: COLLAPSED_ICON_COUNT }, (_, i) => (
        <Skeleton.Button
          key={i}
          active
          size="small"
          shape="square"
          className="app-fallback-side-nav__icon"
        />
      ))}
    </Sider>
  );
};
